import { useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { candidateEndpoints } from '@/modules/candidates/constants';

import { candidateFeedbackQueryKeys } from './queryKeys';

type UseCandidateFeedbacksQueryParams = {
  jobId: string;
  candidateId: string;
};

export const useCandidateFeedbacksQuery = ({
  jobId,
  candidateId,
}: UseCandidateFeedbacksQueryParams) => {
  return useQuery({
    queryKey: candidateFeedbackQueryKeys.detail(jobId, candidateId),
    gcTime: 0,
    queryFn: async () => {
      const { data } = await fetchClient.GET(
        candidateEndpoints.candidateFeedback,
        {
          params: {
            path: {
              jobId,
              candidateId,
            },
          },
        },
      );
      return data;
    },
  });
};
